import './Select.css';
import PropTypes from 'prop-types';

const Select = (props) => {
  return (
    <select
      name={props.name}
      id={props.id}
      className={'fmc-select ' + props.className}
      value={props.selectedVal}
      size={props.size ? props.size : 1}
      onChange={props.onChange}
    >
      {!props.emptyDefault && <option value=""></option>}
      {props.options?.map((option) => (
        <option value={option.value} key={option.value}>
          {option.name}
        </option>
      ))}
    </select>
  );
};

Select.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  selectedVal: PropTypes.any,
  size: PropTypes.number,
  onChange: PropTypes.func,
  emptyDefault: PropTypes.any,
  options: PropTypes.array,
};

export default Select;
